import { useState, useCallback } from 'react'

const useTempBooleanState = (time: number = 2000) => {
  const [state, setState] = useState<boolean>(false)
  const triggerUpdate = useCallback(() => {
    setState(true)
    const timeout = setTimeout(() => {
      setState(false)
    }, time)
    return () => clearTimeout(timeout)
  }, [time])

  return [state, triggerUpdate] as const
}

export default useTempBooleanState
